import { JsonModel, Model } from './model'

export class Chain extends Model {
    id: number
    abbreviation: string
    code: string
    name: string
    supplier_brand_id: number
    supplier_brand_name: string

    constructor(json: JsonChain) {
        super(json)

        this.id = json.id
        this.abbreviation = json.abbreviation
        this.code = json.code
        this.name = json.name
        this.supplier_brand_id = json.supplier_brand_id
        this.supplier_brand_name = json.supplier_brand_name
    }
}

export interface JsonChain extends JsonModel {
    id: number
    abbreviation: string
    code: string
    name: string
    supplier_brand_id: number
    supplier_brand_name: string
}
